import * as angular from "angular";
import {IWindowService} from "angular";
import {PrinterService} from "../../commons/services/printer-service.service";

export class AuthService {

  /* @ngInject */
  constructor(private $log, private $auth, private $state, private $window: IWindowService,
              private printerService: PrinterService, private UserService) {
  }

  // logout() {
  //   this.$auth.logout()
  //     .then(() => {
  //       var printingConfig = this.printerService.getPrintingConfig();
  //       const language = this.$window.localStorage.getItem('NG_TRANSLATE_LANG_KEY');
  //       const siteOmsSettings = this.$window.localStorage.getItem('siteOmsSettings');
  //       const siteDeliveriesSettings = this.$window.localStorage.getItem('siteDeliveriesSettings');
  //       const siteFulfillmentSettings = this.$window.localStorage.getItem('siteFulfillmentSettings');
  //       this.$window.localStorage.clear();
  //       this.$window.localStorage.setItem('NG_TRANSLATE_LANG_KEY', language);
  //       this.$window.localStorage.setItem('siteOmsSettings', siteOmsSettings);
  //       this.$window.localStorage.setItem('siteDeliveriesSettings', siteDeliveriesSettings);
  //       this.$window.localStorage.setItem('siteFulfillmentSettings', siteFulfillmentSettings);
  //       this.printerService.setPrintingConfig(printingConfig);
  //       this.UserService.logout();
  //
  //       // BringozHelp.shutDown();
  //       // this.intercom.shutDown();
  //       this.$state.go('authentication.login')
  //     })
  //     .catch((error) => {
  //       this.$log.debug(error);
  //     })
  // }

  logout() {
    return this.$auth.logout();
  }

}

angular
  .module('bringoz.admin.authentication')
  .service('authService', AuthService);
